/** @format */
import React, { useState, useEffect } from 'react'
import { _$, Select, Option, Tooltip, Icon, Collapse, CollapseItem } from 'kpc-react'
import styled from 'styled-components'
import AlarmingCollapseItem from './AlarmingCollapseItem'
import useGlobalData from 'src/hooks/useGlobalData'
import { RegionStateType } from 'src/store/globalDataSlice'
import Api from 'src/api/ApiAlarming'
import { useParams } from 'react-router-dom'
import { get } from 'lodash'
import variable from 'src/static/styles/var'
import { request, dayToSecond } from 'src/utils'
import moment from 'moment'
const MonitorAlarmingCard: React.FC<{ className?: string }> = ({ className }) => {
  const params = useParams()
  const productType = get(params, 'productType')
  const [alarmingList, setAlarmingList] = useState([])
  const [currentProduct, setCurrentProduct] = useState<number>()
  const gloabalRegionList = useGlobalData('monitorRegionList') as RegionStateType['list']
  useEffect(() => {
    getAlarming()
  }, [])

  const getAlarming = async () => {
    const result = await request(Api.getAlarming, {
      data: {
        StartTime: moment().subtract(dayToSecond(30), 's').unix(),
        EndTime: moment().unix()
      }
    })
    if (result?.data?.alertingList) {
      if (productType !== undefined) {
        const find = result?.data?.alertingList.find(item => {
          return item.productType === parseInt(productType)
        })
        collapseChange(find?.productType)
      } else {
        collapseChange(result?.data?.alertingList[0]?.productType)
      }
      setAlarmingList(result?.data?.alertingList || [])
    } else {
      setAlarmingList([])
      setCurrentProduct(undefined)
    }
  }

  // 切换卡片
  const collapseChange = value => {
    if (value !== undefined) {
      setTimeout(() => {
        const anchorElement = document.getElementById(value)
        if (anchorElement) {
          const top = anchorElement.offsetTop - 58
          window.scrollTo({ top })
        }
      }, 300)
      setCurrentProduct(value)
    }
  }

  return (
    <div className={className}>
      <div className="filter">
        <Select value={currentProduct} onChange={val => collapseChange(val)} filterable>
          {alarmingList?.length
            ? alarmingList.map(({ productType, productName }) => (
                <Option key={productType} value={productType}>
                  {productName}
                </Option>
              ))
            : null}
        </Select>
        <Tooltip content={_$('近30天未恢复的告警')}>
          <Icon style={{ fontSize: '14px', marginLeft: '8px' }} className="icon ion-help-circled" />
        </Tooltip>
      </div>
      <Collapse
        value={[currentProduct]}
        on$change-value={(_c, value) => {
          setCurrentProduct(value[0])
        }}
        accordion
        arrow="left"
      >
        {alarmingList?.length
          ? alarmingList.map(({ productType, productName, resources }) => (
              <CollapseItem
                id={productType}
                key={productType}
                value={productType}
                b-title={
                  <div className="collapse-item-title">
                    <span className="product-name">{productName}</span>
                    <span>{_$('共资源告警数', { msg: resources?.length })}</span>
                  </div>
                }
              >
                <AlarmingCollapseItem
                  resources={resources}
                  regionList={gloabalRegionList}
                  productType={productType}
                />
              </CollapseItem>
            ))
          : null}
      </Collapse>
    </div>
  )
}
export default styled(MonitorAlarmingCard)`
  .filter {
    display: flex;
    & > * {
      /* margin-right: 5px; */
      margin-bottom: 0;
      line-height: 30px;
    }
  }
  .k-collapse {
    margin-top: 16px;
    padding: 0;
    .k-collapse-item {
      &.k-active {
        & > .k-title {
          .k-arrow {
            color: #0091ea;
          }
          .collapse-item-title {
            span {
              color: #0091ea;
            }
            .product-name {
              font-size: 16px;
              font-weight: 500;
            }
          }
        }
        .k-wrapper {
          border: none;
          .alram-item .k-header {
            margin-top: 0;
          }
        }
      }
      & > .k-title {
        height: 48px;
        line-height: 48px;
        background: #fff;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        .k-arrow {
          height: 48px;
        }
        .collapse-item-title {
          span {
            color: #999;
            font-size: 12px;
            font-weight: 400;
            margin-right: 8px;
          }
        }
      }
      .k-wrapper {
        padding: 0 16px 16px;
        border-top: 1px solid #e5e5e5;
        .alram-item {
          box-shadow: none;
          .k-header {
            padding: 0;
            height: 30px;
            line-height: 30px;
            margin-top: 12px;
            .k-title {
              display: block;
              .instance-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .instance-box {
                  display: flex;
                  align-items: center;
                }
                p {
                  margin-bottom: 0;
                }
                .instance-name,
                .region {
                  font-weight: bold;
                }
              }
            }
          }
          .k-body {
            padding: 0;
            .text {
              margin: 5px 0;
              line-height: 20px;
              &:hover {
                cursor: pointer;
                color: ${variable.primaryColor};
              }
              span {
                margin-right: 20px;
              }
            }
          }
        }
      }
    }
  }
`
